import { createApp } from 'vue'
import App from './app.vue'
import vuetify from './vuetify'
import router from './router'
import pinia from './store'

createApp(App)
  .use(vuetify)
  .use(router)
  .use(pinia)
  .mount('#app')
